module.exports = __webpack_public_path__ + "media/rotate_small.aa929d64.mp4";